import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-themes-settings',
  templateUrl: './themes-settings.component.html',
  styleUrls: ['./themes-settings.component.scss']
})
export class ThemesSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
